import React from 'react';
import CostBreakdown from './CostBreakdown';
import DutyCostBreakdown from './DutyCostBreakdown';
import { renderDate } from '../../../util/formatUtils';
import { Box, HStack, VStack, Text } from '@chakra-ui/react';
import PrintReceiptHeader from '../../snippets/PrintReceiptHeader';
import { dutyCertCategories } from '../../../constants/certificateConstant';

const CertificateBill = React.forwardRef(({ title, costs, data, isFromBlankCert }, ref) => (
  <Box p={6} ref={ref}>
    <PrintReceiptHeader />
    <HStack w="100%" justifyContent="space-between" alignItems="flex-start">
      <VStack spacing={0} alignItems="flex-start" w="35%">
        <Text fontSize="sm" fontWeight="bold">
          Managing Director
        </Text>
        <Text fontSize="sm">{data?.millName}</Text>
        <Text fontSize="sm">{data?.millAddress}</Text>
      </VStack>
      <VStack spacing={0} alignItems="flex-start">
        <Text fontSize="sm">Bill No: {data?.billNo}</Text>
        <Text fontSize="sm">Date: {renderDate(data?.billDate)}</Text>
      </VStack>
    </HStack>

    {costs?.certFor?.toUpperCase() === 'DUTY' ? (
      isFromBlankCert ? (
        <CostBreakdown data={costs} billFor={title} isFromBlankCert />
      ) : (
        <DutyCostBreakdown data={costs} billFor={title} />
      )
    ) : (
      <CostBreakdown data={costs} billFor={title} />
    )}

    <VStack w="100%" alignItems="flex-end" mt={10}>
      <VStack>
        <Text
          p={2}
          fontSize="lg"
          width="300px"
          fontWeight="bold"
          textAlign="center"
          borderBottom="2px solid black"></Text>
        <Text fontWeight="bold">Authorized Signature</Text>
      </VStack>
    </VStack>

    {costs?.dutyCertCost?.category === dutyCertCategories.A ||
    costs?.dutyCertCost?.category === dutyCertCategories.C ? (
      <Box mt={10}>
        <Text w="fit-content" fontSize="sm" fontWeight="bold" borderBottom="1px solid black">
          যন্ত্রপাতি ও যন্ত্রাংশ:
        </Text>
        <Text fontSize="sm">
          বিটিএমএ কর্তৃক ইস্যুকৃত প্রত্যেকটি প্রত্যয়ন পত্রের এলসি এমাউন্টের/কনসাইনমেন্ট ভ্যালুর প্রতি এক লক্ষ টাকা পর্যন্ত ৩৭৫/- (তিনশত পঁচাত্তার) টাকা এবং তৎপরবর্তী প্রতি ২৫,০০০/- টাকার জন্য ৯৪/- (চুরানব্বই) টাকা হারে প্রদান করার জন্য সবিনয় অনুরোধ করছি।
        </Text>
      </Box>
    ) : costs?.dutyCertCost?.category === dutyCertCategories.B ? (
      <Box mt={10}>
        <Text w="fit-content" fontSize="sm" fontWeight="bold" borderBottom="1px solid black">
          রং রসায়নের ক্ষেত্রে:
        </Text>
        <Text fontSize="sm">
        বিটিএমএ কর্তৃক ইস্যুকৃত প্রত্যেকটি প্রত্যয়ন পত্রের এলসি এমাউন্টের/কনসাইনমেন্ট  ভ্যালুর প্রতি এক লক্ষ টাকা পর্যন্ত ১৫০/- (একশত পঞ্চাশ) টাকা এবং তৎপরবর্তী প্রতি ২৫,০০০/- টাকার জন্য ৩৮/- (আটত্রিশ) টাকা হারে প্রদান করার জন্য সবিনয় অনুরোধ করছি।
        </Text>
      </Box>
    ) : costs?.certFor?.toUpperCase() === 'DUTY' && !isFromBlankCert ? (
      <Box mt={10}>
        <Text fontSize="sm">
        পলিয়েষ্টার ষ্ট্যাপল ফাইবার, ভিসকস ষ্ট্যাপল ফাইবার এবং টেনসিল ও ফ্লাক্স ফাইবার এবং তৎসংশ্লিষ্ট অন্যান্য ফাইবার আমদাণীর ক্ষেত্রে ১০০ মেট্রিক টনের পর্যন্ত প্রত্যেকটি প্রত্যয়নপত্রের জন্য ৩,৭৫০/- (তিন হাজার সাতশত পঞ্চাশ) টাকা এবং ১০০ মেট্রিক টনের উপরে প্রত্যেকটি প্রত্যয়ন পত্রের জন্য ৭,৫০০/- (সাত হাজার পাঁচশত) টাকা হারে প্রদান করার জন্য সবিনয় অনুরোধ করছি।
        </Text>
      </Box>
    ) : null}

    <Text mt={5} opacity={0.7} fontSize="sm" fontWeight="bold">
      {' '}
      ***This is an electronically generated bill.{' '}
    </Text>
  </Box>
));

CertificateBill.displayName = 'CertificateBill';

export default CertificateBill;
